import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosError } from 'axios';

import { InsurancePolicyUserList } from '@models/InsurancePolicyUser';
import { InsurancePolicyUserApi } from '@apis/InsurancePolicyUserApi';
import { SagaPayload } from '@utils/typescript';
import { Pagination } from '@models/Pagination';
import { getResponseError } from '@utils/error';

import {
  insurancePolicyUsersFetch,
  InsurancePolicyUsersFetchPayload,
  insurancePolicyUserCreate,
  InsurancePolicyUserCreatePayload,
  insurancePolicyUserUpdate,
  InsurancePolicyUserUpdatePayload,
  stateUpdate,
  StateUpdatePayload,
  stateReload,
} from './action';

function* handleInsurancePolicyUsersFetch({ payload }: SagaPayload<InsurancePolicyUsersFetchPayload>) {
  const state: StateUpdatePayload = { policyUsers: null, pagination: undefined };
  try {
    const [policyUsers, pagination] = (yield call(InsurancePolicyUserApi.getAll, payload)) as [InsurancePolicyUserList[], Pagination];
    state.policyUsers = policyUsers;
    state.pagination = pagination;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleInsurancePolicyUserCreate({ payload }: SagaPayload<InsurancePolicyUserCreatePayload>) {
  try {
    yield call(InsurancePolicyUserApi.create, payload);
    yield put(stateReload());
    const state: StateUpdatePayload = { isSuccess: true, serverErrors: {} };
    yield put(stateUpdate(state));
  } catch (e) {
    const serverErrors = getResponseError(e as AxiosError).errors;
    const state: StateUpdatePayload = { isSuccess: false, serverErrors };
    yield put(stateUpdate(state));
  }
}

function* handleInsurancePolicyUserUpdate({ payload }: SagaPayload<InsurancePolicyUserUpdatePayload>) {
  try {
    yield call(InsurancePolicyUserApi.update, payload);
    yield put(stateReload());
    const state: StateUpdatePayload = { isSuccess: true, serverErrors: {} };
    yield put(stateUpdate(state));
  } catch (e) {
    const serverErrors = getResponseError(e as AxiosError).errors;
    const state: StateUpdatePayload = { isSuccess: false, serverErrors };
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(insurancePolicyUsersFetch, handleInsurancePolicyUsersFetch);
  yield takeLatest(insurancePolicyUserCreate, handleInsurancePolicyUserCreate);
  yield takeLatest(insurancePolicyUserUpdate, handleInsurancePolicyUserUpdate);
}
